import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import React, { useState } from 'react';
import { ExtendedRadioGroup } from 'framework/components/ExtendedRadioGroup';
import { ICustomerAccountLine, ISettlementProposal } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import { Mode } from './Mode';

interface IProps extends DialogProps {
	proposals: ISettlementProposal[];
	lines: ICustomerAccountLine[];
	confirm: (mode: Mode) => void;
	cancel: VoidFunction;
}

export const RegisterPaymentForSaleModeForm = ({ confirm, cancel, lines, proposals, ...rest }: IProps) => {
	const [mode, setMode] = useState<Mode>('group');
	const strings = useLocalization();

	return (
		<Dialog
			{...rest}
			scroll='paper'>
			<DialogTitle>{strings.makeAChoice}</DialogTitle>
			<DialogContent dividers>
				<ExtendedRadioGroup<Mode>
					selected={mode}
					setSelected={setMode}
					options={[
						{ value: 'single', label: strings.oneSale, caption: strings.paymentOneSaleCaption, disabled: lines.length === 0 },
						{ value: 'group', label: strings.multipleSales, caption: strings.paymentMultipleSalesCaption, disabled: lines.length <= 1 },
						{ value: 'settlementProposal', label: strings.settlementProposal, caption: strings.paymentSpsCaption, disabled: proposals.length === 0 },
					]}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={cancel}
					color='primary'>
					{strings.cancel}
				</Button>
				<Button disabled>{strings.previous}</Button>
				<Button
					onClick={() => confirm(mode)}
					color='primary'>
					{strings.confirmChoice}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
